import CurrencyFactory from '@woocommerce/currency';

export default class VariableProduct {
    constructor() {
        this.init();
        this.booking();
    }

    init() {
        this.price = 0;
        this.personCount = 0;
        this.hasEnoughSpace = false;
        this.hasSetDate = false;
        this.showNote = false;

        this.storeCurrency = CurrencyFactory();
        this.storeCurrency.setCurrency({
            code: themeVars.price_params.currency_code,
            symbol: themeVars.price_params.currency_format_symbol,
            symbolPosition: themeVars.price_params.currency_position,
            thousandSeparator:
                themeVars.price_params.currency_format_thousand_sep,
            decimalSeparator:
                themeVars.price_params.currency_format_decimal_sep,
            precision: themeVars.price_params.currency_format_num_decimals,
        });

        const variationsEl = document.querySelector('[data-variations]');

        if (null === variationsEl) {
            return;
        }

        const variations = variationsEl.querySelectorAll('[data-variation]');

        this.variationId = variationsEl.getAttribute('data-variations');

        const element = document.querySelector(
            '[data-calculator-per-person="element"]'
        );
        const input = element.querySelector(
            '[data-calculator-per-person="input"]'
        );
        const plus = element.querySelector('[data-calculator-qty="plus"]');
        const minus = element.querySelector('[data-calculator-qty="minus"]');
        const price = element.querySelector(
            '[data-calculator-per-person="price"]'
        );
        const submit = document.querySelector(
            '.variations_form button[type="submit"]'
        );
        const note = document.querySelector('[data-booking-note]');

        const recalculateEvent = new CustomEvent('recalculate');
        const inputEvent = new Event('input', {
            bubbles: true,
        });

        if (this.showNote === false) {
            note.style.display = 'none';
        }

        plus.addEventListener('click', () => {
            input.value = parseInt(input.value) + 1;
            input.dispatchEvent(inputEvent);
            variationsEl.dispatchEvent(recalculateEvent);
        });

        minus.addEventListener('click', () => {
            let currentValue = parseInt(input.value);

            if (currentValue > 1) {
                input.value = parseInt(input.value) - 1;
                input.dispatchEvent(inputEvent);
                variationsEl.dispatchEvent(recalculateEvent);
            }
        });

        variations.forEach((variation) => {
            const qtyInput = variation.querySelector(
                '[data-variation-qty="input"]'
            );
            qtyInput.addEventListener('input', () => {
                variationsEl.dispatchEvent(recalculateEvent);
            });

            const qtyPlus = variation.querySelector(
                '[data-variation-qty="plus"]'
            );
            const qtyMinus = variation.querySelector(
                '[data-variation-qty="minus"]'
            );

            qtyPlus.addEventListener('click', () => {
                qtyInput.value = parseInt(qtyInput.value) + 1;
                qtyInput.dispatchEvent(inputEvent);
                variationsEl.dispatchEvent(recalculateEvent);
            });

            qtyMinus.addEventListener('click', () => {
                let currentValue = parseInt(qtyInput.value);

                if (currentValue > 0) {
                    qtyInput.value = parseInt(qtyInput.value) - 1;
                    qtyInput.dispatchEvent(inputEvent);
                    variationsEl.dispatchEvent(recalculateEvent);
                }
            });
        });

        variationsEl.addEventListener('recalculate', () => {
            this.price = 0;
            this.personCount = 0;

            variations.forEach((variation) => {
                const price = parseInt(
                    variation.getAttribute('data-variation')
                );
                const count = parseInt(
                    variation.getAttribute('data-person-count')
                );
                let qty = parseInt(
                    variation.querySelector('[data-variation-qty="input"]')
                        .value
                );

                if (isNaN(qty)) {
                    qty = 0;
                }

                this.price = this.price + price * qty;
                this.personCount = this.personCount + count * qty;
            });

            const $bookingPrice = $('[data-booking_price]');
            $bookingPrice.html(
                '<span class="price"><span class="amount">' +
                    this.storeCurrency.formatAmount(this.price) +
                    '</span></span>'
            );

            input.dispatchEvent(inputEvent);
        });

        input.addEventListener('input', () => {
            input.value = input.value
                .replace(/[^0-9.]/g, '')
                .replace(/(\..*)\./g, '$1');
            let persons = parseInt(input.value);

            if (persons > this.personCount) {
                price.innerHTML = price.getAttribute('data-calculator-error');
                this.hasEnoughSpace = false;
            } else {
                price.innerHTML = this.storeCurrency.formatAmount(
                    this.price / persons
                );
                this.hasEnoughSpace = true;
            }

            if ('' === input.value) {
                price.innerHTML = '&ndash;';
                this.hasEnoughSpace = false;
            }

            if (this.hasEnoughSpace === true && this.hasSetDate === true) {
                submit.disabled = false;
            } else {
                submit.disabled = true;
            }
        });

        variationsEl.dispatchEvent(recalculateEvent);
        input.dispatchEvent(inputEvent);
    }

    booking() {
        const $pickerWrap = $('.wceb_picker_wrap');

        if ($pickerWrap.length < 1) {
            return;
        }

        $pickerWrap.slideDown(200);
        $pickerWrap.find('.wceb_error').remove();

        wceb.dateFormat = wceb_object.booking_dates[this.variationId];
        wceb.firstDate = parseInt(wceb_object.first_date[this.variationId]);
        wceb.bookingMin = parseInt(wceb_object.min[this.variationId]);
        wceb.bookingMax =
            wceb_object.max[this.variationId] === ''
                ? ''
                : parseInt(wceb_object.max[this.variationId]);
        wceb.bookingDuration = parseInt(
            wceb_object.booking_duration[this.variationId]
        );

        wceb.dateFormat === 'one'
            ? $pickerWrap.find('.show_if_two_dates').hide()
            : $pickerWrap.find('.show_if_two_dates').show();

        let variation = {};
        variation['variation_id'] = this.variationId;

        wceb.pickers.init();
        wceb.pickers.render(variation);

        const startDate = document.querySelector('[name="start_date_submit"]');
        const submit = document.querySelector(
            '.variations_form button[type="submit"]'
        );
        const note = document.querySelector('[data-booking-note]');

        if (startDate.value === null) {
            this.hasSetDate = false;
            submit.disabled = true;
        }

        $('body').on('update_price', () => {
            if (startDate.value === null) {
                this.hasSetDate = false;
            } else {
                this.hasSetDate = true;

                const currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);

                const selectedDate = new Date(startDate.value);
                selectedDate.setHours(0, 0, 0, 0);

                console.log(currentDate.getTime());
                console.log(selectedDate.getTime());

                if (
                    currentDate.getTime() === selectedDate.getTime() ||
                    currentDate.getTime() + 24 * 3600 * 1000 ===
                        selectedDate.getTime()
                ) {
                    this.showNote = true;
                } else {
                    this.showNote = false;
                }
            }

            if (this.hasEnoughSpace === true && this.hasSetDate === true) {
                submit.disabled = false;
            } else {
                submit.disabled = true;
            }

            if (this.showNote === false) {
                note.style.display = 'none';
            } else {
                note.style.display = 'flex';
            }
        });
    }
}
